/**
 * BriefStatusBadge (v1.8.0) — coloured pill for `DesignAssetBrief.status`.
 */

import React from 'react';
import Chip from '@mui/material/Chip';

export interface BriefStatusBadgeProps {
  status?: string;
}

const STATUS_LABEL: Record<string, string> = {
  pending: 'Pending',
  preBriefReady: 'Pre-brief',
  storyboardReady: 'Storyboard',
  visualsReady: 'Visuals',
  accepted: 'Accepted',
  rejected: 'Rejected',
};

const STATUS_COLOR: Record<string, 'default' | 'primary' | 'success' | 'error' | 'warning'> = {
  pending: 'default',
  preBriefReady: 'primary',
  storyboardReady: 'primary',
  visualsReady: 'warning',
  accepted: 'success',
  rejected: 'error',
};

export const BriefStatusBadge: React.FC<BriefStatusBadgeProps> = ({ status }) => {
  if (!status) return null;
  return (
    <Chip
      size="small"
      label={STATUS_LABEL[status] ?? status}
      color={STATUS_COLOR[status] ?? 'default'}
      data-testid="design-brief-status-badge"
    />
  );
};
